// services/subscriptionService.js
import apiClient from './apiClient';
import API_ENDPOINTS from '../config/apiEndpoints';

class SubscriptionService {
    async fetchSubscriptions() {
        try {
            const response = await apiClient.get(API_ENDPOINTS.SUBSCRIPTION.BASE);
            return response.data;
        } catch (error) {
            console.error('[SubscriptionService] Error fetching subscriptions:', error);
            throw error;
        }
    }

    async getUserSubscriptions() {
        try {
            const response = await apiClient.get(API_ENDPOINTS.SUBSCRIPTION.BASE);
            return { data: response.data }; // Format attendu par le contexte
        } catch (error) {
            console.error('[SubscriptionService] Error fetching user subscriptions:', error);
            throw error;
        }
    }

    async fetchPlans() {
        try {
            const response = await apiClient.get(API_ENDPOINTS.SUBSCRIPTION.PLANS);
            return response.data;
        } catch (error) {
            console.error('[SubscriptionService] Error fetching plans:', error);
            throw error;
        }
    }

    async createSubscription(planId, billingCycle) {
        try {
            const response = await apiClient.post(API_ENDPOINTS.SUBSCRIPTION.BASE, {
                plan_id: planId,
                billing_cycle: billingCycle
            });
            return response.data;
        } catch (error) {
            console.error('[SubscriptionService] Error creating subscription:', error);
            throw error;
        }
    }

    async cancelSubscription(subscriptionId) {
        try {
            const response = await apiClient.post(API_ENDPOINTS.SUBSCRIPTION.CANCEL(subscriptionId));
            return response.data;
        } catch (error) {
            console.error('[SubscriptionService] Error canceling subscription:', error);
            throw error;
        }
    }
}

const subscriptionServiceInstance = new SubscriptionService();
export default subscriptionServiceInstance;
